import React from 'react';

import { BulkVerificationRunTracker } from './useBulkVerificationRun';
import { percentProcessed } from './bulkVerificationRunProgress';

/** The "Business verification N%" pill beside the database title while a run is in progress. */
const BulkVerificationRunBadge: React.FC<{
  tracker: BulkVerificationRunTracker;
}> = ({ tracker }) => {
  if (!tracker.run || !tracker.isRunning) return null;
  return (
    <span className='bite-status-pill bite-status-pill--upload bdb-bulk-run-badge'>
      <span aria-hidden='true' className='bite-status-pill__dot' />
      {' Business verification '}
      <span className='bdb-bulk-run-num'>
        {percentProcessed(tracker.run)}%
      </span>
    </span>
  );
};

export default BulkVerificationRunBadge;
